export default {
  /**
   * Diện khuyến khích
   */
  Encourage: 2,

  /**
   * Diện ưu tiên
   */
  Priority: 1,
}
